import { useReferralsContext } from '@user/components/Referrals/context'
import {
  ReferralTypes,
  setReferralTypeActionCreator,
} from '@user/components/Referrals/state'
import { useFormikContext } from 'formik'
import { ILeadFormModel } from '@user/components/Leads/AddLeadPage/typings'
import { referralDataMapperModelToDTO } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralDrawer/hooks/utils'
import { ReferralFormProps } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralForm/UpdateReferralForm'
import { ReferralFormVariant } from '@user/components/Referrals/components/UpdateReferral/TidalUpdateReferral'

export function useHandlers({ formVariant }: ReferralFormProps) {
  const [state, dispatch] = useReferralsContext()
  const context = useFormikContext<ILeadFormModel>()

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    const source = event.target.value as ReferralTypes
    dispatch(setReferralTypeActionCreator(source))
    if (formVariant === ReferralFormVariant.Inline) {
      const model = referralDataMapperModelToDTO({
        ...state,
        referralType: source,
      })
      context?.setFieldValue?.('referral', model)
    }
  }

  return {
    onChange,
  } as const
}
